import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { AccountType, AccountTypeFilterObject } from "@shared/types/graphqlGenerated";

const ACCOUNT_TYPES_QUERY = gql`
  query AccountTypes_Shared_Query($filter: AccountTypeFilterObject) {
    viewer {
      accountTypes(filterObject: $filter) {
        value
        presentation
      }
    }
  }
`;

interface AccountTypesData {
  viewer: {
    accountTypes: AccountType[];
  };
}
interface AccountTypesVariables {
  filter: AccountTypeFilterObject;
}

const useAccountTypesQuery = (
  options?: QueryHookOptions<AccountTypesData, AccountTypesVariables>
) => {
  return useQuery<AccountTypesData>(ACCOUNT_TYPES_QUERY, options);
};

export type { AccountTypesData };
export { useAccountTypesQuery, ACCOUNT_TYPES_QUERY };
